module.exports = __webpack_public_path__ + "img/mn.7bd9a92.svg";